<template>
  <div class="app_wrapper">
    <router-view />
    <van-tabbar class="wrapper_tabbar" v-model="active" route>
      <!-- <van-tabbar-item icon="home-o" replace to="/">设备</van-tabbar-item>
      <van-tabbar-item icon="search" replace to="/chargeTemplate">收费模板</van-tabbar-item>
      <van-tabbar-item icon="friends-o" replace to="/monthlyTemplate">包月模板</van-tabbar-item> -->

      <van-tabbar-item icon="home-o" replace to="/home">首页</van-tabbar-item>
      <van-tabbar-item icon="friends-o" replace to="/me">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import ResizeMixin from "@/maintain/mixin/ResizeHandler";

export default {
  name: "Home",
  mixins: [ResizeMixin],
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.app_wrapper {
  padding-bottom: 50px;

  .wrapper_tabbar {
    z-index: 999;
  }
}
</style>
